import { render, staticRenderFns } from "./ExpandableTextBox.vue?vue&type=template&id=52df77e0&"
import script from "./ExpandableTextBox.vue?vue&type=script&lang=js&"
export * from "./ExpandableTextBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports